import React, { useEffect, useState } from "react";
import Header from './Header';
import Sidebar from './Sidebar';
import Booking from '../Components/Booking';
import { useNavigate } from "react-router-dom";


const OrderBooking = () => {
  const navigate = useNavigate();
  const [userlog, setUserlog] = useState(localStorage.getItem("Logkey"));

  useEffect(() => {
    if (userlog === undefined || userlog === null) {
      navigate("/");
    }
  }, []);
  return (
    <>
      <Header />
      <Sidebar />
      <Booking />
    </>
  )
}

export default OrderBooking
